export function PageLoader() {
  return (
    <div className="grid min-h-[55vh] place-items-center" role="status" aria-live="polite">
      <div className="text-center">
        <span className="mx-auto block size-8 animate-spin rounded-full border-2 border-blue-200 border-t-royal motion-reduce:animate-none" />
        <span className="mt-4 block text-sm font-medium text-slate-600">Preparing this page…</span>
      </div>
    </div>
  );
}
